import { render, staticRenderFns } from "./ProducerTurnoverComponent.vue?vue&type=template&id=d412fa7a&scoped=true"
import script from "./ProducerTurnoverComponent.vue?vue&type=script&lang=js"
export * from "./ProducerTurnoverComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d412fa7a",
  null
  
)

export default component.exports